export const APP_NAME = "NOORA HEALTH APP";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
